import { ref } from 'vue';

export const usePrimitiveModalState = () => {
    const isOpened = ref(false);

    const open = () => {
        isOpened.value = true;
    };
    const close = () => {
        isOpened.value = false;
    };

    return {
        isOpened,
        open,
        close,
    }
}
